import { render, staticRenderFns } from "./AccountSetupScreen.vue?vue&type=template&id=5dc9b12e&scoped=true"
import script from "./AccountSetupScreen.vue?vue&type=script&lang=js"
export * from "./AccountSetupScreen.vue?vue&type=script&lang=js"
import style0 from "./AccountSetupScreen.vue?vue&type=style&index=0&id=5dc9b12e&prod&lang=scss"
import style1 from "./AccountSetupScreen.vue?vue&type=style&index=1&id=5dc9b12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9b12e",
  null
  
)

export default component.exports